<template>
 <div class="card vac-message-highlight">
	 <div>
		 <img :src="`https://hyreads.com/${image}`" style="height:250px;width:100%;border-radius:25px;" v-if="image">
		 <video  style="height:250px;width:100%;border-radius:25px;" controls v-else-if="video">
		<source :src="`https://hyreads.com${video}`" type="video/mp4" />
		<source :src="`https://hyreads.com${video}`" type="video/ogg" />
		<source :src="`https://hyreads.com${video}`" type="video/webm" />
	</video>
	 </div>
   <span>{{text}}</span>
 </div>
</template>

<script>
export default {
	props:{
		text:{

		},
		image:{

		},
		video:{

		}
	}

}
</script>

<style lang="scss" scoped>
.vac-message-highlight {
	padding: 12px 18px 6px;
	box-shadow: 0 1px 2px -1px rgba(0, 0, 0, 0.1),
		0 1px 2px -1px rgba(0, 0, 0, 0.11), 0 1px 5px -1px rgba(0, 0, 0, 0.11);
}
.vac-message-actions-wrapper {
	.vac-options-container {
		position: absolute;
		top: 2px;
		right: 10px;
		height: 40px;
		width: 70px;
		overflow: hidden;
		border-top-right-radius: 8px;
	}

	.vac-blur-container {
		position: absolute;
		height: 100%;
		width: 100%;
		left: 8px;
		bottom: 10px;
		background: var(--chat-message-bg-color);
		filter: blur(3px);
		border-bottom-left-radius: 8px;
	}

	.vac-options-me {
		background: var(--chat-message-bg-color-me);
	}

	.vac-message-options {
		background: var(--chat-icon-bg-dropdown-message);
		border-radius: 50%;
		position: absolute;
		top: 7px;
		right: 7px;

		svg {
			height: 17px;
			width: 17px;
			padding: 5px;
			margin: -5px;
		}
	}

	.vac-message-emojis {
		position: absolute;
		top: 6px;
		right: 30px;
	}

	.vac-menu-options {
		right: 15px;
	}

	.vac-menu-left {
		right: -118px;
	}

	@media only screen and (max-width: 768px) {
		.vac-options-container {
			right: 3px;
		}

		.vac-menu-left {
			right: -50px;
		}
	}
}


@import './styles/index.scss';
</style>